export enum TabConstants {
  BILLING = '/tabs/billing',
  HOME_TAB = '/tabs/home',
  TIMELINE_TAB = '/tabs/timeline',
  TIMES_TAB = '/tabs/times',
  QUICK_ACTIONS_TAB = '/tabs/quickActions',
  ATTACHMENT_TAB = '/tabs/attachment',
  SHARE_TAB = '/tabs/share',
  COMPLETE_CHART_TAB = '/tabs/completeChart',
  SIGNER_TAB = '/tabs/signer',
  VITALS_TAB = '/tabs/vitals',
  CHART_ROUTE = '/tabs/chart',
  PATIENT_INFO_ROUTE = '/tabs/patientInfo',
  PATIENT_INFO_TABLET = '/tabs/patientInfoTablet',
  PATIENT_DEMOGRAPHICS = '/tabs/patientDemographics',
  PATIENT_NARRATIVE = '/tabs/patientNarrative',
  PATIENT_ALLERGIES = '/tabs/patientAllergies',
  PATIENT_ALLERGIES_LIST = '/tabs/patientAllergiesList',
  PATIENT_MEDICAL_HISTORY = '/tabs/patientMedicalHistory',
  MEDICAL_HISTORY_LOOKUP = '/tabs/medicalHistoryLookup',
  PATIENT_MEDICATIONS = '/tabs/patientMedications',
  PATIENT_MEDICATIONS_SEARCH = '/tabs/patientMedicationsSearchLookup',
  TIMELINE_ACTIONS_SEARCH = '/tabs/actionSearch',
  ADD_MEDICATIONS_ADMINISTERED = '/tabs/medicationsAdministered',
  ADD_MEDICATIONS_ADMINISTERED_SEARCH = '/tabs/medicationsAdministeredSearch',
  CARDIAC_PROCEDURE = '/tabs/cardiacProcedure',
  INTUBATION_PROCEDURE = '/tabs/intubationProcedure',
  TRIP_INFORMATION = '/tabs/tripInformation',
  PICKUP_ADDRESS = '/tabs/pickupAddress',
  AIRWAY_PROCEDURE = '/tabs/airwayProcedure',
  ASSESSMENT_PROCEDURE = '/tabs/assessmentsProcedure',
  CHILDBIRTHOB_PROCEDURE = '/tabs/childbirthOBProcedure',
  INITIATE_IV_PROCEDURE = '/tabs/initiateIVProcedure',
  IMMOBILIZATION_PROCEDURE = '/tabs/immobilizationProcedure',
  MEDICAL_CONSULT_PROCEDURE = '/tabs/medicalConsultProcedure',
  EXTRICATION_PROCEDURE = '/tabs/extricationProcedure',
  IMAGING_ULTRASOUND_PROCEDURE = '/tabs/imagingUltrasoundProcedure',
  OPERATIONS_PROCEDURE = '/tabs/operationsProcedure',
  RESCUE_PROCEDURE = '/tabs/rescueProcedure',
  PN_MEDICATION_PROCEDURE = '/tabs/pnMedicationProcedure',
  VENTILATOR_PROCEDURE = '/tabs/ventilatorProcedure',
  CRITICAL_CARE_PROCEDURE = '/tabs/criticalCareProcedure',
  HOSPITAL_NOTIFY_PROCEDURE = '/tabs/hospitalNotifyProcedure',
  TITRATE_PROCEDURE = '/tabs/TITRATE_PROCEDURE',
  WOUND_CARE_PROCEDURE = '/tabs/woundCareProcedure',
  LABS_PROCEDURE = '/tabs/labsProcedure',
  PERTINENT_NEGATIVE_PROCEDURE = '/tabs/pertinentNegativeProcedure',
  VENTRICULAR_ASSIST_DEVICE_PROCEDURE = '/tabs/ventricularAssistDeviceProcedure',
  CAD_IMPORT = '/tabs/cadImport',
  CC_HPI = '/tabs/ccHpi',
  CC_HPI_INJURY_CAUSE = '/tabs/ccHpiInjuryCause',
  DESTINATION_ADDRESS = '/tabs/destinationAddress',
  INSURANCE_INFORMATION = '/tabs/insuranceInformation',
  RELATIONSHIPS_AND_GUARANTORS = '/tabs/relationshipsAndGuarantors',
  PCS_INFORMATION = '/tabs/pcsInformation',
  AUTHORIZATION_INFORMATION = '/tabs/authorizationInformation',
  CMS_INFORMATION = '/tabs/cmsInformation',
  PAYMENT_INFORMATION = '/tabs/paymentInformation',
  PATIENT_SEARCH = '/tabs/patientSearch',
  PATIENT_SEARCH_RESULTS = '/tabs/patientSearchResults',
  FACTORS_AFFECTING_CARE = '/tabs/factorsAffectingCare',
  EXPOSURE = '/tabs/exposure',
  NEMSIS_DATA = '/tabs/nemsisData',
  SCENE_DESCRIPTION = '/tabs/sceneDescription',
  INITIAL_ASSESSMENT = '/tabs/initialAssessment',
  INITIAL_ASSESSMENT_COMMENTS = '/tabs/initialAssessmentComments',
  GLASSGOW_COMMA_SCORE = '/tabs/glassgowCommaScore',
  PEDIATRIC_TRAUMA_SCORE = '/tabs/pediatricTraumaScore',
  REVISED_TRAUMA_SCORE = '/tabs/revisedTraumaScore',
  STROKE_SCORE = '/tabs/strokeScore',
  VITALS_STROKE_SCORE = '/tabs/vitalsStrokeScore',
  VITALS_PAIN_QUALITY = '/tabs/vitalsPainQuality',
  VITALS_PAIN_SCALES = '/tabs/vitalsPainScales',
  VITALS_SEDATION_SCALE = '/tabs/vitalsSedationScale',
  VITALS_WITHDRAWAL_SCALES = '/tabs/withdrawalScales',
  DRAIN_PROCEDURE = '/tabs/drainProcedure',
  DO_NOT_RESUSCITATE = '/tabs/doNotResuscitate',
  BARRIERS_TO_CARE = '/tabs/barriersToCare',
  PREFERRED_LANGUAGE = '/tabs/preferredLanguage',
  SYSTEM = '/tabs/diagnosis/system',
  SYMPTOMS = '/tabs/diagnosis/symptoms',
  IMPRESSION = '/tabs/diagnosis/impression',
  ADDITIONAL_ASSESSMENTS = '/tabs/additionalAssessments',
  ADDITIONAL_ASSESSMENT_SUMMARY = '/tabs/additionalAssessmentsSummary',
  FLUIDS = '/tabs/fluids',
  BODY_ASSESSMENT = '/tabs/bodyAssessment',
  BODY_ASSESSMENT_COMMENTS = '/tabs/comments',
  BLOOD_PRODUCT_ADMINISTRATION_PROCEDURE = '/tabs/bloodProductAdministrationProcedure',
}
